import React, { forwardRef } from "react";
import { BackIcon } from "../icons/BackIcon";

interface BackButtonProps {
  onClick: () => void;
  ariaLabel?: string;
  id?: string;
}

export const BackButton = forwardRef<HTMLButtonElement, BackButtonProps>(
  ({ onClick, ariaLabel = "Go back", id = "sheet-back-button" }, ref) => (
    <button
      ref={ref}
      id={id}
      onClick={onClick}
      className="btn-icon btn-icon--lg"
      aria-label={ariaLabel}
    >
      <BackIcon />
    </button>
  ),
);

BackButton.displayName = "BackButton";
